module.exports = __webpack_public_path__ + "img/git-branch-01.1b7fdc42.svg";